import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { GET_POSTAL_ADDRESS_URL } from '@shared/utils/api/configs/URL';

import type {
  GetPostalAddressPayload,
  GetPostalAddressRawResponse,
  GetPostalAddressResult,
} from '../types/getPostalAddress.types';

export const POSTAL_ADDRESS_TAGS = 'getPostalAddress';

export const getPostalAddress = (builder: BuilderType) =>
  builder.query<GetPostalAddressResult, GetPostalAddressPayload>({
    providesTags: [POSTAL_ADDRESS_TAGS],
    query: (data) => ({
      data,
      method: 'POST',
      url: GET_POSTAL_ADDRESS_URL,
    }),
    transformResponse: (response: GetPostalAddressRawResponse) => {
      if (!response.Result?.Results?.length || response.Result?.Found === 0) {
        return {
          address: '',
          blkNo: '',
          building: '',
          roadName: '',
          postal: '',
          latitude: 0,
          longitude: 0,
        };
      }

      const result = response.Result.Results[0];
      return {
        address: result.Address ?? '',
        blkNo: result.Blk_No ?? '',
        building: result.Building ?? '',
        roadName: result.Road_Name ?? '',
        postal: result.Postal ?? '',
        latitude: parseFloat(result.Latitude),
        longitude: parseFloat(result.Longitude),
      };
    },
  });
